module.exports = __webpack_public_path__ + "static/media/7dd4df5329 1.4c1943c2.png";